<template>
  <view class="dialog-btn-slot-demo">
    <cube-button  bind:click="onClickDialog">Dialog - btn slot</cube-button>
    <cube-dialog  wx:ref="dialog" icon="info">
      <view slot="title">测试标题</view>
      <view slot="btns" class="dialog-btn-slot">
        <view bind:tap="onCloseDialog">这是btn-slot</view>
      </view>
    </cube-dialog>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  methods: {
    onClickDialog () {
      this.$refs.dialog.show()
    },
    onCloseDialog () {
      this.$refs.dialog.hide()
    }
  }
})
</script>

<style lang="stylus">
@require "@mpxjs/mpx-cube-ui/src/common/stylus/variable.styl"
@require "@mpxjs/mpx-cube-ui/src/common/stylus/mixin.styl"

.dialog-btn-content
  text-align center
.dialog-btn-slot
  font-size 16px
  text-align center
  padding-top 14px
  padding-bottom 14px
  color #fc9153
  border-top-1px($var(border-color-normal))
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-dialog": "@mpxjs/mpx-cube-ui/src/components/dialog/index"
    }
  }
</script>
